import {createToast} from "../../Toast/features/createToast";

export const testimonials = () => {
    const form = document.querySelector('form[name="testimonial"]') as HTMLFormElement

    if (!form) return

    const textareas = form.querySelectorAll('textarea') as NodeListOf<HTMLTextAreaElement>
    const button1 = form.querySelector('button[type="submit"]#testimonial_validate') as HTMLButtonElement
    const button2 = form.querySelector('button[type="submit"].content__submit') as HTMLButtonElement

    const buttons = [button1, button2]

    textareas?.forEach((textarea, index) => {
        buttons[index].addEventListener('click', e => {
            e.preventDefault()
            if (textarea.value.length < 300) {
                createToast('error_testimonial', document.querySelector('.container-toast') as HTMLElement)
            } else {
                form.submit()
            }
        })
    })
}
